import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
import * as Sentry from "@sentry/react";
import ErrorBoundary from "./ErrorBoundary";
import { BASE_URL } from "./config";


// if(BASE_URL === "https://cmp.sourcingbrains.com/backend/"){
//   Sentry.init({
//     // dsn: "https://c080ba15945af3e04089cab92415f09d@o4510379711463424.ingest.de.sentry.io/4510379713560656", // nitesh
//     dsn: "https://4df53e4f4241b96ffec9c941295e2f64@o4510380156518400.ingest.de.sentry.io/4510380158156880", // kuldeep Sir
//     sendDefaultPii: true
//   });
// }

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    {/* <ErrorBoundary> */}
      <App />
    {/* </ErrorBoundary> */}
  </Provider>
);

reportWebVitals();
